// extracted by mini-css-extract-plugin
export var o_cardyoutube = "cardYouTube-module--o_cardyoutube--046f5";
export var o_cardyoutube__title = "cardYouTube-module--o_cardyoutube__title--1872f";
export var o_cardyoutube__video = "cardYouTube-module--o_cardyoutube__video--47bce";